import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

function RoleProtectedRoute({ role: requiredRole, children }) {
  const { currentUser, role, mustChangePassword, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // 🚨 If password must be changed, redirect immediately
    if (mustChangePassword && location.pathname !== "/change-password") {
      navigate("/change-password");
    }
  }, [mustChangePassword, navigate, location]);

  if (loading) return null;

  // 🔐 Not logged in
  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  // 🔒 Logged in but wrong role
  if (requiredRole && role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default RoleProtectedRoute;
